function useAsync() {
  const symbolNull = Symbol(null);
  const requests = [];
  let target = symbolNull;
  return {
    set(val) {
      target = val;
      requests.forEach((resolve) => resolve(target));
    },
    get() {
      return new Promise((resolve) => {
        if (target === symbolNull) {
          requests.push(resolve);
        } else {
          resolve(target);
        }
      });
    }
  };
}

export default useAsync;
